export default "__VITE_ASSET__C_IPf8CT__"